// Submit-button spinner: disable the button and reveal its spinner on submit; re-enable on HTMX errors.
document.addEventListener("submit", (e) => {
  const btn = e.target.querySelector("button[data-loading]");
  if (!btn) return;
  if (btn.disabled) return;
  const spinner = document.getElementById(btn.dataset.loading);
  if (spinner) spinner.classList.remove("hidden");
  btn.disabled = true;
  btn.classList.add("opacity-50", "cursor-not-allowed");
});

// Re-enable submit buttons on HTMX network errors so users can retry
function resetFormLoading(evt) {
  const form = evt.detail.elt.closest("form");
  if (!form) return;
  const btn = form.querySelector("button[data-loading]");
  if (!btn) return;
  const spinner = document.getElementById(btn.dataset.loading);
  if (spinner) spinner.classList.add("hidden");
  btn.disabled = false;
  btn.classList.remove("opacity-50", "cursor-not-allowed");
}
document.addEventListener("htmx:responseError", resetFormLoading);
document.addEventListener("htmx:sendError", resetFormLoading);
